import styled from 'styled-components/macro'

import { Title as TitleBase } from '../../styled'
import { mq } from 'styles/mq'

export const Title = styled(TitleBase).attrs({ 'data-thread': '' })`
  ${mq.smallOnly} {
    width: 100%;

    &::before {
      left: 6.5em;
      bottom: 0.7em;
      margin-left: 0.5em;
      right: calc(-1 * var(--container-spacing) * (50 / (50 - 6.25)));
      aspect-ratio: 208 / 234;
      mask-image: url("data:image/svg+xml,%3Csvg width='208' height='234' viewBox='0 0 208 234' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath d='M611.542 0.303972C590.344 37.97 567.006 78.5917 522.735 99.8036C500.095 110.654 474.579 113.488 449.077 110.666C423.575 107.845 396.984 99.6376 371.703 92.102C347.289 84.8233 322.127 78.0267 296.152 76.8452C272.437 75.7664 249.319 80.3344 229.186 91.288C190.897 112.12 168.849 147.562 141.61 177.443C127.794 192.601 112.181 207.024 92.8112 216.982C70.5934 228.406 44.8663 232.212 19.3045 232.745C13.0898 232.875 6.87503 232.812 0.664881 232.65C-0.221627 232.626 -0.221627 233.812 0.664881 233.836C25.8821 234.492 51.8435 233.389 75.6276 225.502C96.7155 218.508 114.372 206.112 129.411 191.811C159.855 162.854 180.323 126.548 215.595 101.297C234.551 87.7277 257.003 79.1963 281.789 78.0188C308.485 76.7543 334.901 82.8278 360.036 89.9484C408.036 103.542 460.735 123.734 511.041 105.968C556.436 89.9366 583.27 52.1086 604.17 15.9757C607.068 10.9692 609.902 5.93491 612.737 0.900653C613.122 0.217038 611.933 -0.383595 611.547 0.303972H611.542Z' fill='black' /%3E%3C/svg%3E");
    }
  }

  ${mq.medium} {
    &::before {
      position: absolute;
      bottom: 0.7em;
      left: 100%;
      margin-left: 0.4em;
      width: 203.7rem;
      aspect-ratio: 2037 / 551;
      mask-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2036.88 550.97'%3E%3Cpath fill='none' stroke='%23000' stroke-miterlimit='10' d='m0,550.47c121.98,0,213.23-17.78,295.75-87.53,82.52-69.75,156.25-156.37,258.12-192.39,86.57-30.6,182.83-19.96,270.79,6.39,79.53,23.82,159.44,60.53,241.77,49.86,79.83-10.35,147.07-63.8,204.09-120.63s109.83-120.18,179.9-159.82c68.15-38.56,149.17-51.8,227.03-43.48,46.25,4.94,92.39,17.56,131.48,42.76,39.38,25.39,69.79,62.19,104.32,93.86,34.54,31.67,76.76,59.51,123.62,59.92' stroke-width='1.5' vector-effect='non-scaling-stroke' /%3E%3C/svg%3E");
    }
  }
`
